"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tslib = require("tslib");

var React = _interopRequireWildcard(require("react"));

var _Box = _interopRequireDefault(require("../../Layout/Box"));

var _Text = _interopRequireDefault(require("../Text"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

var Button = function Button(_a) {
  var _b = _a.variant,
      variant = _b === void 0 ? 'default' : _b,
      sx = _a.sx,
      props = (0, _tslib.__rest)(_a, ["variant", "sx"]);
  return React.createElement(_Box.default, (0, _tslib.__assign)({
    as: "button",
    sx: (0, _tslib.__assign)({
      alignItems: 'stretch',
      bg: 'white',
      border: 'none',
      borderRadius: '12px',
      cursor: 'pointer',
      display: 'inline-flex',
      fontSize: [4, 5],
      fontWeight: 'bold',
      justifyContent: 'center',
      lineHeight: '1em',
      margin: '0 auto',
      overflow: 'hidden',
      padding: '0',
      textAlign: 'center',
      textDecoration: 'none',
      ':hover': {
        backgroundColor: 'black',
        color: 'white'
      }
    }, sx),
    variant: "ctaButtons." + variant + ".root"
  }, props));
};

var Icon = function Icon(_a) {
  var _b = _a.variant,
      variant = _b === void 0 ? 'default' : _b,
      sx = _a.sx,
      props = (0, _tslib.__rest)(_a, ["variant", "sx"]);
  return React.createElement(_Box.default, (0, _tslib.__assign)({
    variant: "ctaButtons." + variant + ".icon",
    sx: (0, _tslib.__assign)({
      alignItems: 'center',
      display: 'inline-flex',
      backgroundColor: 'black',
      px: 5,
      py: 3
    }, sx)
  }, props));
};

var Text = function Text(_a) {
  var _b = _a.variant,
      variant = _b === void 0 ? 'default' : _b,
      sx = _a.sx,
      props = (0, _tslib.__rest)(_a, ["variant", "sx"]);
  return React.createElement(_Text.default, (0, _tslib.__assign)({
    sx: (0, _tslib.__assign)({
      alignSelf: 'center',
      flex: '1 0 auto',
      px: 5,
      color: 'black',
      py: 3
    }, sx),
    variant: "ctaButtons." + variant + ".main"
  }, props));
};

var CtaButton = function CtaButton(_a) {
  var symbol = _a.symbol,
      props = (0, _tslib.__rest)(_a, ["symbol"]);
  return React.createElement(Button, (0, _tslib.__assign)({}, props), React.createElement(Icon, {
    variant: props.variant
  }, symbol), React.createElement(Text, {
    variant: props.variant,
    sx: {
      color: 'inherit'
    }
  }, props.children));
};

CtaButton.displayName = 'CtaButton';
CtaButton.defaultProps = {};
var _default = CtaButton;
exports.default = _default;